import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { statusUpdateUser } from 'services/apiUsers';

const useUpdateUserStatus = () => {
  const queryClient = useQueryClient();
  const {isPending: isUpdating, isSuccess: isUpdated, mutate: updateUserStatus} = useMutation({
    mutationFn: statusUpdateUser,
    onSuccess: (data)=>{
        queryClient.setQueryData(['updatedUserStatus'],data)
        toast.success('Updated Successfully')
        queryClient.invalidateQueries({queryKey:['userList']})
    },
    onError:(error)=>{
        console.log("Error occurred while updating User Status",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })

  return{isUpdating, isUpdated, updateUserStatus}
}

export default useUpdateUserStatus